import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "layer",
  "use": "layer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"layer\">\n<path d=\"M12,18c-0.2,0-0.3,0-0.4-0.1l-10-5C1.2,12.7,1,12.4,1,12c0-0.4,0.2-0.7,0.6-0.9l10-5c0.3-0.1,0.6-0.1,0.9,0l10,5\n\tc0.3,0.2,0.5,0.5,0.5,0.9c0,0.4-0.2,0.7-0.6,0.9l-10,5C12.3,18,12.2,18,12,18z M4.2,12l7.8,3.9l7.8-3.9L12,8.1L4.2,12z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol